import { ReactElement, ReactNode } from "react";
import {
  TableLegacy,
  TableLegacyTHead,
  TableLegacyTR,
  TableLegacyTH,
  TableLegacyTBody,
} from "../../../../../components/table/TableLegacy";

export const StorefrontTable = ({
  showBasket = true,
  children,
}: {
  children: ReactNode;
  showBasket?: boolean;
}): ReactElement => {
  return (
    <TableLegacy>
      <TableLegacyTHead>
        <TableLegacyTR>
          <TableLegacyTH>Format</TableLegacyTH>
          <TableLegacyTH>Dietary</TableLegacyTH>
          <TableLegacyTH>Stock</TableLegacyTH>
          <TableLegacyTH>Price (ex. VAT)</TableLegacyTH>
          <TableLegacyTH>Delivery</TableLegacyTH>
          {showBasket && <TableLegacyTH>Add to basket</TableLegacyTH>}
        </TableLegacyTR>
      </TableLegacyTHead>
      <TableLegacyTBody>{children}</TableLegacyTBody>
    </TableLegacy>
  );
};
